var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackWithText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "22px",
    viewBox: "0 0 92 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "component/text/back") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.5725048,10.3968675 L25.7510161,11.5753788 C26.7273268,12.5516895 26.7273268,14.134602 25.7510161,15.1109127 L20.7237412,20.1378124 L25.7510161,25.1652297 C26.7273268,26.1415404 26.7273268,27.7244528 25.7510161,28.7007636 L24.5725048,29.8792749 C23.5961941,30.8555856 22.0132816,30.8555856 21.0369709,29.8792749 L13.2587963,22.1011003 C12.7209485,21.5632525 12.4794001,20.8413078 12.534151,20.1381035 C12.4794001,19.4348346 12.7209485,18.7128899 13.2587963,18.1750421 L21.0369709,10.3968675 C22.0132816,9.42055677 23.5961941,9.42055677 24.5725048,10.3968675 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CMS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Role-management-list",
    transform: "translate(-22.000000, -81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(10.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn/btn_perious"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "<",
    fill: "#E37B3C",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    mask: "url(#mask-2)",
    fill: "#009DA5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/accent/orange/base"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.000000, 7.000000)",
    fill: "#009DA5",
    fontFamily: "PingFangTC-Semibold, PingFang TC",
    fontSize: 16,
    fontWeight: 500,
    id: "comoponent/text/orange/b1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "Body1"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 19
  }, "\u8FD4\u56DE\u4E0A\u9801")))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackWithText);
export default __webpack_public_path__ + "static/media/backWithText.c70af583a8bd0ddd3c97146c2ff0d1a5.svg";
export { ForwardRef as ReactComponent };